// src/api/apiClient.ts
import { getConfigs } from "../configs/env";

type FetchOptions = RequestInit & { token?: string };

export async function fetchWithAuth(
  path: string,
  options: FetchOptions = {}
): Promise<Response> {
  const isFormData = options.body instanceof FormData;
  const { API_URL } = getConfigs();
  const token = options.token;

  const headers: HeadersInit = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem("redmimbre_user");
    localStorage.removeItem("redmimbre_token");
    window.location.reload();
  }
  if (!response.ok) {
    const errorMessage = await extractDotNetErrorMessage(response);
    throw new Error(errorMessage);
  }

  return response;
}

export async function extractDotNetErrorMessage(
  response: Response
): Promise<string> {
  const errorMessage = `Error ${response.status}`;

  try {
    const contentType = response.headers.get("content-type") || "";
    const text = await response.text(); // Solo puede leerse una vez

    // Acepta también "application/problem+json"
    if (
      contentType.includes("application/json") ||
      contentType.includes("problem+json")
    ) {
      try {
        const json = JSON.parse(text);

        if (json.errors && typeof json.errors === "object") {
          const validationMessages = Object.entries(json.errors)
            .map(([field, messages]) => {
              if (Array.isArray(messages)) {
                return messages.map((msg) => `• ${field}: ${msg}`).join("\n");
              }
              return `• ${field}: ${messages}`;
            })
            .join("\n");

          return `Errores de validación:\n${validationMessages}`;
        }

        if (json.title) {
          return `${json.title} (${json.status || response.status})`;
        }
      } catch {
        // No era JSON válido
      }
    }

    // Fallback: texto plano o error no reconocido
    const match = text.match(/^.*?(System\.[\w.]+Exception:.*?)\r?\n/);
    return match?.[1]?.trim() || text.trim();
  } catch {
    return response.statusText || errorMessage;
  }
}
